---
en:
  market_prices:
    average: Average Price
    avg_power_prices_year: Average power prices {year} [{currency_code}/MWh]
    heading: Market prices
    power_prices_year: Power prices {year}
    price_factor: Price Factor [%]
    realized_price: Realized Price
    reservoir_fill:
      heading: Norwegian hydro reservoir capacity
      y_axis_title: Fill percentage
